<template>
  <div class="wrap_input">
    <input
      :class="inputClass"
      :type="type"
      :value="value"
      :name="name"
      :autocomplete="autocomplete"
      @input="$emit('input', $event.target.value)"
    />
    <span class="focus-input" :data-placeholder="label"></span>
  </div>
</template>

<script>
export default {
  props: {
    type: { type: String, default: "text" },
    value: String,
    label: String,
    name: String,
    autocomplete: String
  },
  computed: {
    inputClass() {
      return {
        input: true,
        "has-val": this.value.trim() !== ""
      };
    }
  }
};
</script>
